import { Controller } from "@hotwired/stimulus"

// Dedupes live message appends in the inbox thread.
//
// Two things append a freshly-sent message to #thread-messages: the send
// request's own Turbo Stream response (so the sender sees it instantly) and
// the model's after_create_commit broadcast over ActionCable (so every other
// staff member watching the thread sees it too). The sender is subscribed to
// that broadcast as well, so without this guard they'd see their message
// twice. Whichever copy lands second is cancelled by matching the message
// bubble's stable DOM id (#conversation_message_<id>).
export default class extends Controller {
  dedupe(event) {
    const stream = event.target
    if (stream.getAttribute("action") !== "append") return
    if (stream.getAttribute("target") !== "thread-messages") return

    const fragment = stream.templateContent
    const bubble = fragment && fragment.querySelector("[id^='conversation_message_']")
    if (!bubble || !document.getElementById(bubble.id)) return

    // Already on screen — swap the render for a no-op so Turbo skips it.
    event.detail.render = () => {}
  }
}
